/*/
	Bootstrap + Popper (Custom Build)
	Only the components this site uses: the navbar collapse, the testimonial
	carousel, the dropdown the coalition search uses for its picker, and the
	modal the events calendar opens for event details.
/*/

import * as Popper from "@popperjs/core";
import Carousel from "bootstrap/js/src/carousel.js";
import Collapse from "bootstrap/js/src/collapse.js";
import Dropdown from "bootstrap/js/src/dropdown.js";
import Modal from "bootstrap/js/src/modal.js";

window.bootstrap = {
	Popper,
	Carousel,
	Collapse,
	Dropdown,
	Modal
};
